import { Record } from "immutable";
import React from "react";

import { ProfileContract } from "@typings/profileContracts";

import { IntlDateFormat, intlFormatDate } from "@services/IntlFormatDate";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./ContractItem.styled";

export const ContractItem = (props: {
  contract: Record<ProfileContract>;
  onSelect: (contract: Record<ProfileContract>) => void;
}) => {
  const translate = useTranslate("batmaid_pwa_profile");
  const showCleaningDate =
    !!props.contract.get("nextCleaningDay") &&
    !!props.contract.get("nextCleaningDate");

  return (
    <Styled.ContractItem>
      <Styled.ContractInfo>
        <Styled.ScheduleIcon />
        <Styled.ContractTime>
          <span>
            {translate(
              `batmaid_pwa_generic.periodicity_${props.contract.get(
                "frequency",
              )}`,
            )}
          </span>
          <span>|</span>
          {showCleaningDate && (
            <span>
              {props.contract.get("nextCleaningDay")}&nbsp;
              {intlFormatDate(
                new Date(props.contract.get("nextCleaningDate")),
                IntlDateFormat["time"],
              )}
            </span>
          )}
          {!showCleaningDate && <span>&mdash;</span>}
        </Styled.ContractTime>
      </Styled.ContractInfo>

      <Styled.ContractInfo>
        <Styled.ClockIcon />
        <Styled.ContractDuration>
          <span>
            {translate("checklist_warning_modal_hours_of_hc_cleaning", {
              hours: props.contract.get("duration"),
            })}
          </span>
          {props.contract.get("extraServices").map(service => (
            <span key={service.type}>
              + {translate(`batmaid_pwa_my_cleanings.extra_${service.type}`)}
            </span>
          ))}
        </Styled.ContractDuration>
      </Styled.ContractInfo>

      <Styled.ConfirmButton onClick={() => props.onSelect(props.contract)}>
        {props.contract.get("cleaningChecklist").isCreated
          ? translate("checklist_warning_modal_edit_checklist")
          : translate("checklist_warning_modal_create_checklist")}
      </Styled.ConfirmButton>
    </Styled.ContractItem>
  );
};
